import React from 'react';
import { Brain } from 'lucide-react';
import { cn } from '@/lib/utils';

interface LogoProps {
  size?: 'standard' | 'large';
  theme?: 'light' | 'dark';
  className?: string;
  showSubtitle?: boolean;
  subtitleText?: string;
}

export const Logo: React.FC<LogoProps> = ({ 
  size = 'standard', 
  theme = 'dark', 
  className,
  showSubtitle = false,
  subtitleText
}) => {
  const isLarge = size === 'large';
  const isDark = theme === 'dark';

  return (
    <div className={cn("flex flex-col items-center", className)}>
      <div className={cn(
        "flex items-center justify-center",
        isLarge ? "gap-4" : "gap-3"
      )}>
        {/* Brain Icon Box */}
        <div className={cn(
          "bg-indigo-600 text-white flex items-center justify-center shadow-lg shadow-indigo-600/20",
          isLarge ? "p-2.5 rounded-2xl" : "p-1.5 rounded-lg"
        )}>
          <Brain size={isLarge ? 34 : 24} strokeWidth={isLarge ? 2.5 : 2} />
        </div>

        {/* Text Logo */}
        <span className={cn(
          "font-bold tracking-tight",
          isLarge ? "text-[28px]" : "text-xl",
          isDark ? "text-white" : "text-slate-900"
        )}>
          Persona<span className={isDark ? "text-indigo-400" : "text-indigo-600"}>Lab</span>
        </span>
      </div>

      {showSubtitle && subtitleText && (
        <p className="text-slate-500 text-sm font-medium mt-2">{subtitleText}</p>
      )}
    </div>
  );
};
